"use client";

import Link from "next/link";
import React from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

// The ladder pointers are stored as the literal string "null" at the ends of a
// chain. A field cleared in Strapi comes back as "", and a machine without the
// extended-sections component has no value at all — both have to collapse to
// "null" or we render a live button pointing at /models/ or /models/null.
const normalize = (value) =>
  !value || value === "null" ? "null" : String(value);

export default function SizeChanger({ data }) {
  const goSmaller = normalize(data?.go_smaller);
  const goBigger = normalize(data?.go_bigger);
  // page.js resolves the stored machine NAME to its real slug, because the two
  // diverge ("K42 v2" -> /models/k42). Fall back to the old behaviour only if
  // the resolver did not run, so the component stays usable on its own.
  const smallerHref = normalize(data?.go_smaller_slug ?? goSmaller.toLowerCase());
  const biggerHref = normalize(data?.go_bigger_slug ?? goBigger.toLowerCase());

  if (goSmaller === "null" && goBigger === "null") return null;

  return (
    <div className="size-changer">
      <h4>Change Model</h4>
      <div className="button-wrapper">
        {goSmaller !== "null" ? (
          <Link href={`/models/${smallerHref}`}>
            <div className="button-div smaller">
              <div className="icon">
                <HiChevronLeft />
              </div>
              <div>
                <h5>Go Smaller</h5>
                <h5 className="machine-name">{goSmaller}</h5>
              </div>
            </div>
          </Link>
        ) : (
          <div className="button-div smaller">
            <div className="icon">
              <HiChevronLeft />
            </div>
            <div>
              <h5>Smallest</h5>
              <h5 className="machine-name">Can&apos;t Go Smaller</h5>
            </div>
          </div>
        )}
        {goBigger !== "null" ? (
          <Link href={`/models/${biggerHref}`}>
            <div className="button-div">
              <div>
                <h5>Go Bigger</h5>
                <h5 className="machine-name">{goBigger}</h5>
              </div>
              <div className="icon">
                <HiChevronRight />
              </div>
            </div>
          </Link>
        ) : (
          <div className="button-div">
            <div>
              <h5>Biggest</h5>
              <h5 className="machine-name">Can&apos;t Go Bigger</h5>
            </div>
            <div className="icon">
              <HiChevronRight />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
